import React, { useState } from "react";
import { StyleSheet, Text, View, type ViewStyle } from "react-native";

import BorderLayout from "@/Components/Layouts/Native/BorderLayout";

type DefaultAvatarProps = {
  width: number;
  height: number;
  borderRadiusTop?: number;
  borderRadiusBottom?: number;
};

const EMOTICONS = [
  "🐭", // Rat
  "🐮", // Ox
  "🐯", // Tiger
  "🐰", // Rabbit
  "🐲", // Dragon
  "🐍", // Snake
  "🐴", // Horse
  "🐑", // Goat
  "🐵", // Monkey
  "🐔", // Rooster
  "🐶", // Dog
  "🐷", // Pig
];

const COLORS = [
  "#FFB3BA",
  "#BAFFC9",
  "#BAE1FF",
  "#FFFFBA",
  "#FFDFBA",
  "#E0BBE4",
  "#957DAD",
  "#D291BC",
  "#FEC8D8",
  "#FFDFD3",
];

export const DefaultAvatar: React.FC<DefaultAvatarProps> = ({
  width,
  height,
  borderRadiusTop = 8,
  borderRadiusBottom = 8,
}) => {
  const [bgColor] = useState<string>(
    COLORS[Math.floor(Math.random() * COLORS.length)] as string,
  );
  const [emoticon] = useState<string>(
    EMOTICONS[Math.floor(Math.random() * EMOTICONS.length)] as string,
  );

  const containerStyle: ViewStyle = {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: bgColor,
    justifyContent: "center",
    alignItems: "center",
  };

  return (
    <BorderLayout
      width={width}
      height={height}
      radiusTop={borderRadiusTop}
      radiusBottom={borderRadiusBottom}
    >
      <View style={containerStyle}>
        <Text style={[styles.emoticon, { fontSize: width * 0.5 }]}>
          {emoticon}
        </Text>
      </View>
    </BorderLayout>
  );
};

const styles = StyleSheet.create({
  emoticon: {
    position: "absolute",
  },
});
